/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React, {useEffect, useState, useCallback, useRef} from 'react';

import {FmlxTab} from 'fmlx-common-ui';
import {isNaN} from 'lodash';
import {useDispatch, useSelector} from 'react-redux';

import {showModal, showPopUp, hidePopUp} from '@/actions/modalActions';
import {setDisableSaveSetupButton, setAdvSetupSelected, showAlert} from '@/actions/setupActions';
import Info from '@/assets/icons/Info.svg';
import {createAdvSetup, editAdvSetup, handleIconInfo} from '@/businesses/advSetupBusiness';
import InputField from '@/components/inputfield/InputField';
import SelectField from '@/components/selectField/SelectField';
import Switch from '@/components/switch/Switch';
import ToggleButton from '@/components/togglebutton/ToggleButton';
import {ADVANCE_SETUP_RESTRICTION} from '@/constants/advSetupConstant';
import {MembraneTypeOptions} from '@/constants/autoProfileEnum';
import {MembraneTypeEnum} from '@/constants/dataEnum';
import {PRESSURE_ROW, ALERT_TYPE} from '@/constants/enums';
import * as APPDATA from '@/constants/pcConstAppData';
import {createNewJsonObject} from '@/libs/appHelper';
import {membraneTypeConverter} from '@/libs/autoProfileHelper';
import {getAdvanceCycleSetup} from '@/selectors/advSetupSelector';

import {MEMBRANE_CUT_OFF_LABEL, MEMBRANE_CUT_OFF} from '../../systemSetting/pressureSetting/pressureSettingConstant';
import GeneralSetup from '../generalSetup/GeneralSetup';
import AdvSetupPageMenu from '../reusable/AdvSetupPageMenu';
import AdvSetupTopMenu from '../reusable/AdvSetupTopMenu';

import './CycleSetup.less';
import '../reusable/AdvSetup.less';

const input = 'input';
const toggle = 'toggle';
const select = 'select';
const button = 'button';
const toggleSwitch = 'switch';

const AdvSetupMenu = {
  GENERAL: 'GENERAL SETUP',
  CONCENTRATE: 'CONCENTRATE',
  DIAFILTRATION: 'BUFFER EXCHANGE',
  PRIME: 'PRIME',
  RECOVERY: 'RECOVERY',
  CYCLE_SETUP: 'CYCLE SETUP',
};

function AdvanceCycleSetup({activePage, moreThan50ml}) {
  const dispatch = useDispatch();

  const {
    advSetupSelected,
    fontSize,
    defaultReturnValvePressure,
    currentProfileParams,
    saveAdvSetup,
    buttonTypeAdv,
    recoveryOfLiquid,
    membraneType,
  } = useSelector(getAdvanceCycleSetup);

  const {MembraneCutOffSize} = currentProfileParams;

  const isOpenReturnValveModal = useRef(false);

  const style = {
    constraint: {
      fontSize,
    },
  };

  const [selectedTab, setSelectedTab] = useState(0);

  const pressureAdvSetup = advSetupSelected
    ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][APPDATA.KEY.PressureAdvSetup]
    : undefined;

  const [isSetupChanged, setIsSetupChanged] = useState(false);
  const [diaphragmPressure, setDiaphragmPressure] = useState(
    advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][APPDATA.KEY.PressureAdvSetup][
          PRESSURE_ROW.DIAPHRAGM
        ]
      : undefined,
  );
  const [returnValvePressure, setReturnValvePressure] = useState(0);
  const [diaphragmFillTime, setDiaphragmFillTime] = useState(
    advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][APPDATA.KEY.DiaphragmTimingOpen]
      : undefined,
  );
  const [diaphragmEmptyTime, setDiaphragmEmptyTime] = useState(
    advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][APPDATA.KEY.DiaphragmTimingClose]
      : undefined,
  );
  // const [autoMixingEnabled, setAutoMixingEnabled] = useState(false);
  const [autoMixingEnabled, setAutoMixingEnabled] = useState(
    advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.MixingSetup][
          APPDATA.KEY.AutoMixingOn
        ]
      : false,
  );
  const [mixingInterval, setMixingInterval] = useState(
    advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.MixingSetup][
          APPDATA.KEY.MixingMinutes
        ]
      : 10,
  );
  const [mixingCycle, setMixingCycle] = useState(
    advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.MixingSetup][
          APPDATA.KEY.MixingCycle
        ]
      : 5,
  );

  const [autoRecoveryEnabled, setAutoRecoveryEnabled] = useState(
    advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.AutoRecoveryFlag]
      : false,
  );

  const [highVolumeBufferEnabled, setHighVolumeBufferEnabled] = useState(
    advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.HighVolumeBufferFlag]
      : false,
  );

  const convertMembraneFormat = (returnValve) => {
    const result = returnValve?.reduce((acc, item) => {
      acc[item.MembraneCutOffSize] = item.ReturnValvePressure;
      return acc;
    }, {});
    return result;
  };

  const [defaultAdvSetup, setDefaultAdvSetup] = useState(APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE);
  const [newReturnValvePressure, setNewReturnValvePressure] = useState(
    convertMembraneFormat(defaultReturnValvePressure?.RCMembraneReturnValvePressure),
  );
  const [newMpesReturnValvePressure, setNewMpesReturnValvePressure] = useState(
    convertMembraneFormat(defaultReturnValvePressure?.MPESMembraneReturnValvePressure),
  );
  const [, setDefReturnValvePressure] = useState(defaultReturnValvePressure);

  const [temporaryDiaphragm, setTemporaryDiaphragm] = useState({
    [APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE]: advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][APPDATA.KEY.PressureAdvSetup][
          PRESSURE_ROW.DIAPHRAGM
        ]
      : undefined,
    [APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE]: advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.DiafiltrationAdvSetup][APPDATA.KEY.PressureAdvSetup][
          PRESSURE_ROW.DIAPHRAGM
        ]
      : undefined,
    [APPDATA.FIELD_NAME.ADV_BUTTON.PRIME]: advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.PrimeAdvSetup][APPDATA.KEY.PressureAdvSetup][
          PRESSURE_ROW.DIAPHRAGM
        ]
      : undefined,
    [APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY]: advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.RecoveryAdvSetup][APPDATA.KEY.PressureAdvSetup][
          PRESSURE_ROW.DIAPHRAGM
        ]
      : undefined,
    [APPDATA.FIELD_NAME.ADV_BUTTON.MIXING]: advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.TubeMixingAdvSetup][APPDATA.KEY.PressureAdvSetup][
          PRESSURE_ROW.DIAPHRAGM
        ]
      : undefined,
  });
  const [temporaryFill, setTemporaryFill] = useState({
    [APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE]: advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][APPDATA.KEY.DiaphragmTimingOpen]
      : undefined,
    [APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE]: advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.DiafiltrationAdvSetup][APPDATA.KEY.DiaphragmTimingOpen]
      : undefined,
    [APPDATA.FIELD_NAME.ADV_BUTTON.PRIME]: advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.PrimeAdvSetup][APPDATA.KEY.DiaphragmTimingOpen]
      : undefined,
    [APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY]: advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.RecoveryAdvSetup][APPDATA.KEY.DiaphragmTimingOpen]
      : undefined,
    [APPDATA.FIELD_NAME.ADV_BUTTON.MIXING]: advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.TubeMixingAdvSetup][APPDATA.KEY.DiaphragmTimingOpen]
      : undefined,
  });
  const [temporaryEmpty, setTemporaryEmpty] = useState({
    [APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE]: advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][APPDATA.KEY.DiaphragmTimingClose]
      : undefined,
    [APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE]: advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.DiafiltrationAdvSetup][
          APPDATA.KEY.DiaphragmTimingClose
        ]
      : undefined,
    [APPDATA.FIELD_NAME.ADV_BUTTON.PRIME]: advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.PrimeAdvSetup][APPDATA.KEY.DiaphragmTimingClose]
      : undefined,
    [APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY]: advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.RecoveryAdvSetup][APPDATA.KEY.DiaphragmTimingClose]
      : undefined,
    [APPDATA.FIELD_NAME.ADV_BUTTON.MIXING]: advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.TubeMixingAdvSetup][APPDATA.KEY.DiaphragmTimingClose]
      : undefined,
  });

  const onClickChangeMode = (e) => {
    setDefaultAdvSetup(e.currentTarget.id);
  };

  const setupModeButtonProp = [
    {
      label: APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE,
      value: APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE,
      onClick: onClickChangeMode,
    },
    {
      label: APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE,
      value: APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE,
      onClick: onClickChangeMode,
    },
    {
      label: APPDATA.FIELD_NAME.ADV_BUTTON.PRIME,
      value: APPDATA.FIELD_NAME.ADV_BUTTON.PRIME,
      onClick: onClickChangeMode,
    },
    {
      label: APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY,
      value: APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY,
      onClick: onClickChangeMode,
    },
    {
      label: APPDATA.FIELD_NAME.ADV_BUTTON.MIXING,
      value: APPDATA.FIELD_NAME.ADV_BUTTON.MIXING,
      onClick: onClickChangeMode,
    },
  ];

  // GENERAL SETUP
  //   const MAX_VALUE = 1000;
  //   const MIN_VALUE = -1000;
  //   const MAX_DIGIT_AFTER_DECIMAL = 1;
  const INCREMENT_VALUE = 0.1;

  // Priming Volume converter (1 volume = 10 membrane) value = 0.1
  const [skipPriming, setSkipPriming] = useState(
    advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.SkipPriming]
      : undefined,
  );
  const [primingVolume, setPrimingVolume] = useState(
    advSetupSelected
      ? Number(
          advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.MembraneFillingCycle],
        ) * 0.1
      : undefined,
  );
  const [manualControlThreshold, setManualControlThreshold] = useState(
    advSetupSelected
      ? advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.ManualControlThreshold]
      : undefined,
  );

  // const hideMembraneFillingCycle = skipPriming === APPDATA.ENUM.SKIP_PRIMING.OFF;

  useEffect(() => {
    // if(advSetupSelected){
    //     setAutoMixingEnabled(!!advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.AutoMixing]);
    // }
    dispatch(setDisableSaveSetupButton(false));
    initializeNewReturnValvePressure();
  }, []);

  useEffect(() => {
    if (isSetupChanged) {
      dispatch(setDisableSaveSetupButton(true));
    }
  }, [isSetupChanged]);

  useEffect(() => {
    checkChanges();
  }, [
    temporaryDiaphragm,
    temporaryEmpty,
    temporaryFill,
    skipPriming,
    primingVolume,
    manualControlThreshold,
    autoMixingEnabled,
  ]);

  useEffect(() => {
    if (isOpenReturnValveModal.current) {
      popupModalReturnValve();
    }
  }, [newReturnValvePressure, newMpesReturnValvePressure, selectedTab]);

  const saveAdvSetupProps = useCallback(() => {
    const testerAdvSetup = createNewJsonObject(advSetupSelected);

    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][APPDATA.KEY.DiaphragmTiming] =
      temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE];
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.DiafiltrationAdvSetup][APPDATA.KEY.DiaphragmTiming] =
      temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE];
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.PrimeAdvSetup][APPDATA.KEY.DiaphragmTiming] =
      temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.PRIME].toString();
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.RecoveryAdvSetup][APPDATA.KEY.DiaphragmTiming] =
      temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY];
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.TubeMixingAdvSetup][APPDATA.KEY.DiaphragmTiming] =
      temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.MIXING];

    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][APPDATA.KEY.DiaphragmTimingOpen] =
      temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE];
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.DiafiltrationAdvSetup][APPDATA.KEY.DiaphragmTimingOpen] =
      temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE];
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.PrimeAdvSetup][APPDATA.KEY.DiaphragmTimingOpen] =
      temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.PRIME];
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.RecoveryAdvSetup][APPDATA.KEY.DiaphragmTimingOpen] =
      temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY];
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.TubeMixingAdvSetup][APPDATA.KEY.DiaphragmTimingOpen] =
      temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.MIXING];

    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][APPDATA.KEY.DiaphragmTimingClose] =
      temporaryEmpty[APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE];
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.DiafiltrationAdvSetup][APPDATA.KEY.DiaphragmTimingClose] =
      temporaryEmpty[APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE];
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.PrimeAdvSetup][APPDATA.KEY.DiaphragmTimingClose] =
      temporaryEmpty[APPDATA.FIELD_NAME.ADV_BUTTON.PRIME];
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.RecoveryAdvSetup][APPDATA.KEY.DiaphragmTimingClose] =
      temporaryEmpty[APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY];
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.TubeMixingAdvSetup][APPDATA.KEY.DiaphragmTimingClose] =
      temporaryEmpty[APPDATA.FIELD_NAME.ADV_BUTTON.MIXING];

    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][APPDATA.KEY.PressureAdvSetup][
      PRESSURE_ROW.DIAPHRAGM
    ] = Number(temporaryDiaphragm[APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE]);
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.DiafiltrationAdvSetup][APPDATA.KEY.PressureAdvSetup][
      PRESSURE_ROW.DIAPHRAGM
    ] = Number(temporaryDiaphragm[APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE]);
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.PrimeAdvSetup][APPDATA.KEY.PressureAdvSetup][
      PRESSURE_ROW.DIAPHRAGM
    ] = Number(temporaryDiaphragm[APPDATA.FIELD_NAME.ADV_BUTTON.PRIME]);
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.RecoveryAdvSetup][APPDATA.KEY.PressureAdvSetup][
      PRESSURE_ROW.DIAPHRAGM
    ] = Number(temporaryDiaphragm[APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY]);
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.TubeMixingAdvSetup][APPDATA.KEY.PressureAdvSetup][
      PRESSURE_ROW.DIAPHRAGM
    ] = Number(temporaryDiaphragm[APPDATA.FIELD_NAME.ADV_BUTTON.MIXING]);

    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.MembraneFillingCycle] =
      Math.round(primingVolume / 0.1).toString();
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.ManualControlThreshold] =
      manualControlThreshold.toString();
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.SkipPriming] =
      skipPriming.toString();

    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.MixingSetup][
      APPDATA.KEY.AutoMixingOn
    ] = autoMixingEnabled.toString();
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.MixingSetup][
      APPDATA.KEY.MixingCycle
    ] = mixingCycle.toString();
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.MixingSetup][
      APPDATA.KEY.MixingMinutes
    ] = mixingInterval.toString();
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.AutoRecoveryFlag] =
      autoRecoveryEnabled.toString();
    testerAdvSetup[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][APPDATA.KEY.HighVolumeBufferFlag] =
      highVolumeBufferEnabled.toString();

    switch (buttonTypeAdv) {
      case APPDATA.SAVE:
        dispatch(editAdvSetup(testerAdvSetup));
        break;
      case APPDATA.SAVE_AS:
        dispatch(createAdvSetup(testerAdvSetup));
        break;

      default:
        break;
    }
    // if (buttonTypeAdv === APPDATA.SAVE) {

    // } else {
    // }
    // dispatch(setupActions.setAdvSetupSelected(testerAdvSetup));
  }, [
    advSetupSelected,
    autoMixingEnabled,
    buttonTypeAdv,
    dispatch,
    manualControlThreshold,
    mixingCycle,
    mixingInterval,
    primingVolume,
    skipPriming,
    temporaryDiaphragm,
    temporaryEmpty,
    temporaryFill,
    autoRecoveryEnabled,
    highVolumeBufferEnabled,
  ]);

  useEffect(() => {
    if (saveAdvSetup) {
      saveAdvSetupProps();
    }
  }, [saveAdvSetup, saveAdvSetupProps]);

  const checkChanges = () => {
    const generalAdv = advSetupSelected.ConfigAdvSetup.GeneralAdvSetup;
    const concentrateAdv = advSetupSelected.ConfigAdvSetup.MainAdvSetup;
    const bufferExchangeAdv = advSetupSelected.ConfigAdvSetup.DiafiltrationAdvSetup;
    const primeAdv = advSetupSelected.ConfigAdvSetup.PrimeAdvSetup;
    const recoveryAdv = advSetupSelected.ConfigAdvSetup.RecoveryAdvSetup;
    const mixingAdv = advSetupSelected.ConfigAdvSetup.TubeMixingAdvSetup;

    if (activePage === AdvSetupMenu.GENERAL) {
      if (
        !(
          Number(manualControlThreshold) === Number(generalAdv.ManualControlThreshold) &&
          skipPriming === generalAdv.SkipPriming &&
          Number(primingVolume) === Number(generalAdv.MembraneFillingCycle) * 0.1
        )
      ) {
        setIsSetupChanged(true);
      }
    } else {
      switch (defaultAdvSetup) {
        case APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE:
          if (
            !(
              Number(temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE]) ===
                Number(concentrateAdv.DiaphragmTimingOpen) &&
              Number(temporaryEmpty[APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE]) ===
                Number(concentrateAdv.DiaphragmTimingClose) &&
              Number(temporaryDiaphragm[APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE]) ===
                Number(concentrateAdv.PressureAdvSetup[2])
            )
          ) {
            setIsSetupChanged(true);
          }
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE:
          if (
            !(
              Number(temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE]) ===
                Number(bufferExchangeAdv.DiaphragmTimingOpen) &&
              Number(temporaryEmpty[APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE]) ===
                Number(bufferExchangeAdv.DiaphragmTimingClose) &&
              Number(temporaryDiaphragm[APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE]) ===
                Number(bufferExchangeAdv.PressureAdvSetup[2])
            )
          ) {
            setIsSetupChanged(true);
          }
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.PRIME:
          if (
            !(
              Number(temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.PRIME]) === Number(primeAdv.DiaphragmTimingOpen) &&
              Number(temporaryEmpty[APPDATA.FIELD_NAME.ADV_BUTTON.PRIME]) === Number(primeAdv.DiaphragmTimingClose) &&
              Number(temporaryDiaphragm[APPDATA.FIELD_NAME.ADV_BUTTON.PRIME]) === Number(primeAdv.PressureAdvSetup[2])
            )
          ) {
            setIsSetupChanged(true);
          }
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY:
          if (
            !(
              Number(temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY]) ===
                Number(recoveryAdv.DiaphragmTimingOpen) &&
              Number(temporaryEmpty[APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY]) ===
                Number(recoveryAdv.DiaphragmTimingClose) &&
              Number(temporaryDiaphragm[APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY]) ===
                Number(recoveryAdv.PressureAdvSetup[2])
            )
          ) {
            setIsSetupChanged(true);
          }
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.MIXING:
          if (
            !(
              Number(temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.MIXING]) === Number(mixingAdv.DiaphragmTimingOpen) &&
              Number(temporaryEmpty[APPDATA.FIELD_NAME.ADV_BUTTON.MIXING]) === Number(mixingAdv.DiaphragmTimingClose) &&
              Number(temporaryDiaphragm[APPDATA.FIELD_NAME.ADV_BUTTON.MIXING]) === Number(mixingAdv.PressureAdvSetup[2])
            )
          ) {
            setIsSetupChanged(true);
          }
          break;
        default:
          break;
      }
    }
  };

  useEffect(() => {
    if (advSetupSelected !== undefined) {
      //   const generalAdv = advSetupSelected.ConfigAdvSetup.GeneralAdvSetup;
      //   const concentrateAdv = advSetupSelected.ConfigAdvSetup.MainAdvSetup;
      //   const bufferExchangeAdv = advSetupSelected.ConfigAdvSetup.DiafiltrationAdvSetup;
      //   const primeAdv = advSetupSelected.ConfigAdvSetup.PrimeAdvSetup;
      //   const recoveryAdv = advSetupSelected.ConfigAdvSetup.RecoveryAdvSetup;

      switch (defaultAdvSetup) {
        case APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE:
          setDiaphragmFillTime(temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE]);
          setDiaphragmEmptyTime(temporaryEmpty[APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE]);
          setDiaphragmPressure(temporaryDiaphragm[APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE]);
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE:
          setDiaphragmFillTime(temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE]);
          setDiaphragmEmptyTime(temporaryEmpty[APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE]);
          setDiaphragmPressure(temporaryDiaphragm[APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE]);
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.PRIME:
          setDiaphragmFillTime(temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.PRIME]);
          setDiaphragmEmptyTime(temporaryEmpty[APPDATA.FIELD_NAME.ADV_BUTTON.PRIME]);
          setDiaphragmPressure(temporaryDiaphragm[APPDATA.FIELD_NAME.ADV_BUTTON.PRIME]);
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY:
          setDiaphragmFillTime(temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY]);
          setDiaphragmEmptyTime(temporaryEmpty[APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY]);
          setDiaphragmPressure(temporaryDiaphragm[APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY]);
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.MIXING:
          setDiaphragmFillTime(temporaryFill[APPDATA.FIELD_NAME.ADV_BUTTON.MIXING]);
          setDiaphragmEmptyTime(temporaryEmpty[APPDATA.FIELD_NAME.ADV_BUTTON.MIXING]);
          setDiaphragmPressure(temporaryDiaphragm[APPDATA.FIELD_NAME.ADV_BUTTON.MIXING]);
          break;
        default:
          setDiaphragmFillTime(0);
          setDiaphragmEmptyTime(0);
          setDiaphragmPressure(0);
          break;
      }
    }
  }, [defaultAdvSetup]);

  useEffect(() => {
    if (advSetupSelected !== undefined) {
      const tempValue = {...temporaryDiaphragm};

      switch (defaultAdvSetup) {
        case APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE:
          tempValue[APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE] = diaphragmPressure;
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE:
          tempValue[APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE] = diaphragmPressure;
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.PRIME:
          tempValue[APPDATA.FIELD_NAME.ADV_BUTTON.PRIME] = diaphragmPressure;
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY:
          tempValue[APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY] = diaphragmPressure;
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.MIXING:
          tempValue[APPDATA.FIELD_NAME.ADV_BUTTON.MIXING] = diaphragmPressure;
          break;
        default:
          break;
      }
      setTemporaryDiaphragm({...tempValue});
    }
  }, [diaphragmPressure]);

  useEffect(() => {
    if (advSetupSelected !== undefined) {
      const tempValue = {...temporaryFill};

      switch (defaultAdvSetup) {
        case APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE:
          tempValue[APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE] = diaphragmFillTime;
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE:
          tempValue[APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE] = diaphragmFillTime;
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.PRIME:
          tempValue[APPDATA.FIELD_NAME.ADV_BUTTON.PRIME] = diaphragmFillTime;
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY:
          tempValue[APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY] = diaphragmFillTime;
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.MIXING:
          tempValue[APPDATA.FIELD_NAME.ADV_BUTTON.MIXING] = diaphragmFillTime;
          break;
        default:
          break;
      }
      setTemporaryFill({...tempValue});
    }
  }, [diaphragmFillTime]);

  useEffect(() => {
    if (advSetupSelected !== undefined) {
      const tempValue = {...temporaryEmpty};

      switch (defaultAdvSetup) {
        case APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE:
          tempValue[APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE] = diaphragmEmptyTime;
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE:
          tempValue[APPDATA.FIELD_NAME.ADV_BUTTON.BUFFER_EXCHANGE] = diaphragmEmptyTime;
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.PRIME:
          tempValue[APPDATA.FIELD_NAME.ADV_BUTTON.PRIME] = diaphragmEmptyTime;
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY:
          tempValue[APPDATA.FIELD_NAME.ADV_BUTTON.RECOVERY] = diaphragmEmptyTime;
          break;
        case APPDATA.FIELD_NAME.ADV_BUTTON.MIXING:
          tempValue[APPDATA.FIELD_NAME.ADV_BUTTON.MIXING] = diaphragmEmptyTime;
          break;
        default:
          break;
      }
      setTemporaryEmpty({...tempValue});
    }
  }, [diaphragmEmptyTime]);

  const onClick = (e) => {
    let value;
    const minValue = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].MIN_VALUE;
    let maxValue = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].MAX_VALUE;
    const maxDigitAfterDecimal = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].DECIMAL_PLACE_ACCURACY;
    const info = ADVANCE_SETUP_RESTRICTION[e.currentTarget.id].INFO;
    const incrementValue = INCREMENT_VALUE;
    switch (e.currentTarget.id) {
      case APPDATA.FIELD_NAME.DIAPHRAGM_FILL_TIME:
        value = diaphragmFillTime;
        break;
      case APPDATA.FIELD_NAME.DIAPHRAGM_EMPTY_TIME:
        value = diaphragmEmptyTime;
        break;
      case APPDATA.FIELD_NAME.BOTTLE_PRESSURE:
        value = pressureAdvSetup[PRESSURE_ROW.BOTTLE];
        maxValue = pressureAdvSetup[PRESSURE_ROW.SOURCE];
        break;
      case APPDATA.FIELD_NAME.DIAPHRAGM_PRESSURE:
        value = diaphragmPressure;
        maxValue = parseFloat(pressureAdvSetup[PRESSURE_ROW.SOURCE]) - 10;
        break;
      default:
        break;
    }
    if (value !== undefined) {
      dispatch(
        showModal({
          modalHeader: e.currentTarget.id,
          value,
          callback: onChange,
          maxValue,
          minValue,
          maxDigitAfterDecimal,
          incrementValue,
          info,
        }),
      );
    }
  };

  const onChange = (e) => {
    if (e.type) {
      switch (e.type) {
        case APPDATA.FIELD_NAME.BOTTLE_PRESSURE:
          // this.updatePressure(PRESSURE_ROW.BOTTLE, e.value);
          break;
        case APPDATA.FIELD_NAME.DIAPHRAGM_PRESSURE:
          // this.updatePressure(PRESSURE_ROW.DIAPHRAGM, e.value);
          setDiaphragmPressure(e.value);
          break;
        case APPDATA.FIELD_NAME.DIAPHRAGM_FILL_TIME:
          // this.update(APPDATA.KEY.DiaphragmTimingOpen, e.value);
          setDiaphragmFillTime(e.value);
          break;
        case APPDATA.FIELD_NAME.DIAPHRAGM_EMPTY_TIME:
          // this.update(APPDATA.KEY.DiaphragmTimingClose, e.value);
          setDiaphragmEmptyTime(e.value);
          break;
        default:
          break;
      }
    }
  };

  const initializeNewReturnValvePressure = () => {
    const tempReturnValvePressure = {...newReturnValvePressure};
    const tempMpesReturnValvePressure = {...newMpesReturnValvePressure};
    const rcValvePressure = advSetupSelected?.ConfigAdvSetup?.MainAdvSetup?.DefaultReturnValvePressure;
    const mpesValvePressure = advSetupSelected?.ConfigAdvSetup?.MainAdvSetup?.MPESReturnValvePressure;

    if (rcValvePressure) {
      rcValvePressure?.forEach((value) => {
        switch (value[APPDATA.KEY.MembraneCutOffSize]) {
          case MEMBRANE_CUT_OFF.CHIP_3_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_3_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_5_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_10_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_30_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_50_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_100_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_300_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          default:
            break;
        }
      });
    }
    if (mpesValvePressure !== undefined) {
      mpesValvePressure?.forEach((value) => {
        switch (value[APPDATA.KEY.MembraneCutOffSize]) {
          case MEMBRANE_CUT_OFF.CHIP_3_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_3_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_5_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_10_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_30_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_50_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_100_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_300_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          default:
            break;
        }
      });
    }
    setNewReturnValvePressure({...tempReturnValvePressure});
    setNewMpesReturnValvePressure({...tempMpesReturnValvePressure});

    if (membraneTypeConverter(membraneType) === MembraneTypeOptions.MPES) {
      setReturnValvePressure(tempMpesReturnValvePressure[MembraneCutOffSize]);
    } else {
      setReturnValvePressure(tempReturnValvePressure[MembraneCutOffSize]);
    }
  };

  const discardReturnValvePressure = () => {
    const tempReturnValvePressure = {...newReturnValvePressure};
    const tempMpesReturnValvePressure = {...newMpesReturnValvePressure};
    if (defaultReturnValvePressure.RCMembraneReturnValvePressure !== undefined) {
      defaultReturnValvePressure.RCMembraneReturnValvePressure?.forEach((value) => {
        switch (value[APPDATA.KEY.MembraneCutOffSize]) {
          case MEMBRANE_CUT_OFF.CHIP_3_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_3_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_5_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_10_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_30_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_50_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_100_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_300_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          default:
            break;
        }
      });
    }
    if (defaultReturnValvePressure.MPESMembraneReturnValvePressure !== undefined) {
      defaultReturnValvePressure.MPESMembraneReturnValvePressure?.forEach((value) => {
        switch (value[APPDATA.KEY.MembraneCutOffSize]) {
          case MEMBRANE_CUT_OFF.CHIP_3_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_3_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_5_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_10_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_30_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_50_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_100_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_300_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          default:
            break;
        }
      });
    }

    setNewReturnValvePressure({...tempReturnValvePressure});
    setNewMpesReturnValvePressure({...tempMpesReturnValvePressure});
  };

  const onClickEditReturnValve = () => {
    const tempReturnValvePressure = {...newReturnValvePressure};
    const tempMpesReturnValvePressure = {...newMpesReturnValvePressure};
    const rcValvePressure = advSetupSelected?.ConfigAdvSetup?.MainAdvSetup?.DefaultReturnValvePressure;
    const mpesValvePressure = advSetupSelected?.ConfigAdvSetup?.MainAdvSetup?.MPESReturnValvePressure;

    if (rcValvePressure !== undefined) {
      rcValvePressure?.forEach((value) => {
        switch (value[APPDATA.KEY.MembraneCutOffSize]) {
          case MEMBRANE_CUT_OFF.CHIP_3_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_3_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_5_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_10_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_30_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_50_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_100_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_300_KDA.toString():
            tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          default:
            break;
        }
      });
    }
    if (mpesValvePressure !== undefined) {
      mpesValvePressure?.forEach((value) => {
        switch (value[APPDATA.KEY.MembraneCutOffSize]) {
          case MEMBRANE_CUT_OFF.CHIP_3_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_3_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_5_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_10_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_30_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_50_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_100_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          case MEMBRANE_CUT_OFF.CHIP_300_KDA.toString():
            tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA] = value[APPDATA.KEY.ReturnValvePressure];
            break;
          default:
            break;
        }
      });
    }

    setNewReturnValvePressure({...tempReturnValvePressure});
    setNewMpesReturnValvePressure({...tempMpesReturnValvePressure});
    isOpenReturnValveModal.current = true;
    popupModalReturnValve();
  };

  const handleChangeTabReturnValvePressure = (index) => {
    setSelectedTab(index.index);
    popupModalReturnValve();
  };

  const popupModalReturnValve = useCallback(() => {
    const popUpButton = [
      {
        id: APPDATA.DISCARD,
        isPrimaryButton: false,
        onClick: onClickButton,
        label: APPDATA.DISCARD,
      },
      {
        id: APPDATA.APPLY,
        isPrimaryButton: true,
        onClick: onClickButton,
        label: APPDATA.APPLY,
      },
    ];

    const membraneListMPES = [
      {left: MEMBRANE_CUT_OFF.CHIP_3_KDA, right: MEMBRANE_CUT_OFF.CHIP_50_KDA},
      {left: MEMBRANE_CUT_OFF.CHIP_5_KDA, right: MEMBRANE_CUT_OFF.CHIP_100_KDA},
      {left: MEMBRANE_CUT_OFF.CHIP_10_KDA, right: MEMBRANE_CUT_OFF.CHIP_300_KDA},
      {left: MEMBRANE_CUT_OFF.CHIP_30_KDA, right: null},
    ];

    const membraneListRC = [
      {left: MEMBRANE_CUT_OFF.CHIP_3_KDA, right: MEMBRANE_CUT_OFF.CHIP_30_KDA},
      {left: MEMBRANE_CUT_OFF.CHIP_5_KDA, right: MEMBRANE_CUT_OFF.CHIP_100_KDA},
      {left: MEMBRANE_CUT_OFF.CHIP_10_KDA, right: MEMBRANE_CUT_OFF.CHIP_300_KDA},
    ];

    const itemTabs = [
      {
        title: MembraneTypeEnum.MPES,
        content: (
          <div className="container-return-valve-modal">
            <div className="header-title">{APPDATA.FIELD_NAME.MOLECULAR_WEIGHT_CUT_OFF_SIZE}</div>
            <div className="membrane-list">
              {membraneListMPES.map((row) => (
                <>
                  <Input
                    label={MEMBRANE_CUT_OFF_LABEL[row.left]}
                    value={newMpesReturnValvePressure[row.left]}
                    unit={APPDATA.UNIT.psi}
                    onClick={onClickInputMpesReturnValve}
                    disabled={false}
                  />
                  {row.right ? (
                    <Input
                      label={MEMBRANE_CUT_OFF_LABEL[row.right]}
                      value={newMpesReturnValvePressure[row.right]}
                      unit={APPDATA.UNIT.psi}
                      onClick={onClickInputMpesReturnValve}
                      disabled={false}
                    />
                  ) : (
                    <div />
                  )}
                </>
              ))}
            </div>
          </div>
        ),
      },
      {
        title: MembraneTypeEnum.RC,
        content: (
          <div className="container-return-valve-modal">
            <div className="header-title">{APPDATA.FIELD_NAME.MOLECULAR_WEIGHT_CUT_OFF_SIZE}</div>
            <div className="membrane-list">
              {membraneListRC.map((row) => (
                <>
                  <Input
                    label={MEMBRANE_CUT_OFF_LABEL[row.left]}
                    value={newReturnValvePressure[row.left]}
                    unit={APPDATA.UNIT.psi}
                    onClick={(e) => onClickInputReturnValve(MEMBRANE_CUT_OFF_LABEL[row.left], e)}
                    disabled={false}
                  />
                  {row.right ? (
                    <Input
                      label={MEMBRANE_CUT_OFF_LABEL[row.right]}
                      value={newReturnValvePressure[row.right]}
                      unit={APPDATA.UNIT.psi}
                      onClick={(e) => onClickInputReturnValve(MEMBRANE_CUT_OFF_LABEL[row.right], e)}
                      disabled={false}
                    />
                  ) : (
                    <div />
                  )}
                </>
              ))}
            </div>
          </div>
        ),
      },
    ];
    dispatch(
      showPopUp({
        popUpTitle: APPDATA.MESSAGES.RETURN_VALVE_PRESSURE_SETTINGS.TITLE,
        popUpText: (
          <div className="return-valve-pressure-tabs">
            <FmlxTab
              id="return-valve-pressure-tabs"
              variant={FmlxTab.Variant.FULLWIDTH}
              type={FmlxTab.Type.CONTAINED}
              items={itemTabs}
              onChange={handleChangeTabReturnValvePressure}
              selectedTab={selectedTab}
            />
          </div>
        ),
        popUpButton,
        popUpHideCloseButton: true,
      }),
    );
  }, [newReturnValvePressure, newMpesReturnValvePressure, selectedTab]);

  const onClickButton = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.APPLY:
        updateReturnValvePressure(newReturnValvePressure, newMpesReturnValvePressure);
        dispatch(hidePopUp());
        isOpenReturnValveModal.current = false;
        break;
      case APPDATA.DISCARD: {
        dispatch(hidePopUp());
        isOpenReturnValveModal.current = false;
        discardReturnValvePressure();
        break;
      }
      case APPDATA.CLOSE: {
        const tempReturnValvePressure = {
          [MEMBRANE_CUT_OFF.CHIP_3_KDA]: '',
          [MEMBRANE_CUT_OFF.CHIP_5_KDA]: '',
          [MEMBRANE_CUT_OFF.CHIP_10_KDA]: '20',
          [MEMBRANE_CUT_OFF.CHIP_30_KDA]: '15',
          [MEMBRANE_CUT_OFF.CHIP_50_KDA]: '10',
          [MEMBRANE_CUT_OFF.CHIP_100_KDA]: '',
          [MEMBRANE_CUT_OFF.CHIP_300_KDA]: '',
        };
        setNewReturnValvePressure({...tempReturnValvePressure});
        setNewMpesReturnValvePressure({...tempReturnValvePressure});
        break;
      }
      default:
        break;
    }
  };

  const updateReturnValvePressure = (value, mpesValue) => {
    const param = defaultReturnValvePressure.RCMembraneReturnValvePressure.map((defaultRV) => {
      const membraneCutOffSize = defaultRV[APPDATA.KEY.MembraneCutOffSize];
      return {
        ...defaultRV,
        [APPDATA.KEY.ReturnValvePressure]: value[membraneCutOffSize],
      };
    });

    const mpesParam = defaultReturnValvePressure.MPESMembraneReturnValvePressure.map((defaultRV) => {
      const membraneCutOffSize = defaultRV[APPDATA.KEY.MembraneCutOffSize];
      return {
        ...defaultRV,
        [APPDATA.KEY.ReturnValvePressure]: mpesValue[membraneCutOffSize],
      };
    });

    let tempPressure = APPDATA.EMPTY_FIELD;
    let advSetupSelected1 = advSetupSelected;
    advSetupSelected1 = createNewJsonObject(advSetupSelected);
    advSetupSelected1[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][APPDATA.KEY.DefaultReturnValvePressure] =
      param;
    advSetupSelected1[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][APPDATA.KEY.MPESReturnValvePressure] =
      mpesParam;
    if (MembraneCutOffSize !== undefined) {
      let selectedSetup =
        advSetupSelected1?.[APPDATA.KEY.ConfigAdvSetup]?.[APPDATA.KEY.MainAdvSetup]?.[
          APPDATA.KEY.DefaultReturnValvePressure
        ];

      if (membraneTypeConverter(membraneType) === MembraneTypeOptions.MPES) {
        selectedSetup =
          advSetupSelected1?.[APPDATA.KEY.ConfigAdvSetup]?.[APPDATA.KEY.MainAdvSetup]?.[
            APPDATA.KEY.MPESReturnValvePressure
          ];
      }

      tempPressure = selectedSetup.find((val) => val[APPDATA.KEY.MembraneCutOffSize] === MembraneCutOffSize)?.[
        APPDATA.KEY.ReturnValvePressure
      ];
    }
    const tempReturnValvePressure = {
      [MEMBRANE_CUT_OFF.CHIP_3_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_5_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_10_KDA]: '20',
      [MEMBRANE_CUT_OFF.CHIP_30_KDA]: '15',
      [MEMBRANE_CUT_OFF.CHIP_50_KDA]: '10',
      [MEMBRANE_CUT_OFF.CHIP_100_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_300_KDA]: '',
    };

    setNewReturnValvePressure({...tempReturnValvePressure});
    setNewMpesReturnValvePressure({...tempReturnValvePressure});
    setDefReturnValvePressure(param);
    setReturnValvePressure(tempPressure);
    dispatch(setDisableSaveSetupButton(true));
    dispatch(setAdvSetupSelected(advSetupSelected1));
    // forceUpdate();
  };

  const onClickInputMpesReturnValve = (e) => {
    const props = {
      maxDigitAfterDecimal: ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.BOTTLE_PRESSURE].DECIMAL_PLACE_ACCURACY,
      incrementValue: 1,
      currentValue: 0,
      headerTitle: 'Test 123',
      minValue: ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.BOTTLE_PRESSURE].MIN_VALUE,
      maxValue:
        ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.BOTTLE_PRESSURE].MAX_VALUE > pressureAdvSetup[PRESSURE_ROW.SOURCE]
          ? pressureAdvSetup[PRESSURE_ROW.SOURCE]
          : ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.BOTTLE_PRESSURE].MAX_VALUE,
      callback: onChangeMpesReturnValvePressure,
      validatorInput: undefined,
      info: ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.BOTTLE_PRESSURE].INFO,
    };
    switch (e.currentTarget.id) {
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_3_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_5_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_10_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_30_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_50_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_100_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_300_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        break;
      default:
        break;
    }
    showNumpad(props);
  };

  const onClickInputReturnValve = (label, e) => {
    const props = {
      maxDigitAfterDecimal: ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.BOTTLE_PRESSURE].DECIMAL_PLACE_ACCURACY,
      incrementValue: 1,
      currentValue: 0,
      headerTitle: label,
      minValue: ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.BOTTLE_PRESSURE].MIN_VALUE,
      maxValue:
        ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.BOTTLE_PRESSURE].MAX_VALUE > pressureAdvSetup[PRESSURE_ROW.SOURCE]
          ? pressureAdvSetup[PRESSURE_ROW.SOURCE]
          : ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.BOTTLE_PRESSURE].MAX_VALUE,
      callback: (e) => onChangeReturnValvePressure(label, e),
      validatorInput: undefined,
      info: ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.BOTTLE_PRESSURE].INFO,
    };
    switch (label) {
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_3_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_5_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_10_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_30_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_50_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_100_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_300_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        break;
      default:
        break;
    }
    showNumpad(props);
  };

  const showNumpad = (props) => {
    dispatch(
      showModal({
        modalHeader: props.headerTitle,
        value: props.currentValue,
        callback: props.callback,
        maxValue: props.maxValue,
        minValue: props.minValue,
        maxDigitAfterDecimal: props.maxDigitAfterDecimal,
        incrementValue: props.incrementValue,
        unit: props.unit,
        validatorInput: props.validatorInput,
        info: props.info,
      }),
    );
  };

  const onChangeReturnValvePressure = (label, e) => {
    const tempReturnValvePressure = {...newReturnValvePressure};

    switch (label) {
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_3_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_3_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_5_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_10_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_30_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_50_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_100_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_300_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA] = e.value;
        break;
      default:
        break;
    }

    setNewReturnValvePressure({...tempReturnValvePressure});
    popupModalReturnValve();
  };

  const onChangeMpesReturnValvePressure = (e) => {
    const tempMpesReturnValvePressure = {...newMpesReturnValvePressure};

    switch (e.type) {
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_3_KDA]:
        tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_3_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_5_KDA]:
        tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_10_KDA]:
        tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_30_KDA]:
        tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_50_KDA]:
        tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_100_KDA]:
        tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_300_KDA]:
        tempMpesReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA] = e.value;
        break;
      default:
        break;
    }

    setNewMpesReturnValvePressure({...tempMpesReturnValvePressure});
    popupModalReturnValve();
  };

  const generateToggle = (label, onClick) => {
    const ToggleData =
      label === APPDATA.FIELD_NAME.RECOVERY_OF_LIQUID
        ? getDataRecoveryOfLiquid(label, onClick)
        : getDataSkipPriming(onClick, label);
    return (
      <ToggleButton
        label={ToggleData.label}
        buttonProp={ToggleData.buttonProp}
        defaultValue={ToggleData.defaultRecoveryOfLiquid}
        value={ToggleData.value}
        onClick={ToggleData.onClick}
      />
    );
  };

  const generateInputField = (label, input, unit, onClick, hideField, disabled) => (
    <InputField
      label={label}
      inputValue={input}
      unit={unit}
      onClick={onClick}
      hideField={hideField}
      disabled={disabled}
    />
  );

  const generateSelectField = (label, onClick, option, value, unit, onChange, iconAfter) => {
    const styleCustom = {width: '100px'};
    return (
      <div className="fieldWithInfo">
        <SelectField
          label={label}
          value={value}
          unit={unit}
          options={option}
          onChange={(selected) => {
            const e = {
              type: label === '' ? APPDATA.FIELD_NAME.SAFETY_THRESHOLD : label,
              value: selected.value,
            };
            onChange(e);
          }}
          styleCustom={styleCustom}
        />
        {iconAfter && (
          <div className="iconImg">
            <img
              alt={Info}
              src={Info}
              onClick={onInfoClick}
            />
          </div>
        )}
      </div>
    );
  };

  const generateSwitchField = (label, onChange, checked, iconAfter) => (
    <div className="middleAlign">
      <div className="col-md-7">{label}</div>
      <div className="switch-with-icon">
        <Switch
          onChange={onChange}
          checked={checked}
          height={48}
          width={104}
          onColor="#006AF5"
          offColor="#B4B4B4"
          uncheckedIcon={false}
          checkedIcon={false}
        />
        {iconAfter && (
          <div className="iconImg">
            <img
              alt={Info}
              src={Info}
              onClick={() => dispatch(handleIconInfo(label))}
              style={{cursor: 'pointer'}}
            />
          </div>
        )}
      </div>
    </div>
  );

  const onInfoClick = () => {
    dispatch(
      showAlert({
        alertShow: true,
        alertText:
          'Safety Threshold is applicable for Final Volume that is less than 3 mL. To prevent overconcentration, the execution will pause if the target volume is lower than the safety threshold (recommended).',
        alertStyle: ALERT_TYPE.ALERT_INFO,
      }),
    );
  };

  const generateRow = (
    col1,
    col2,
    label1,
    inputValue1,
    unit1,
    hideField1,
    disabled1,
    option1,
    onChange1,
    onClick,
    label2,
    inputValue2,
    unit2,
    hideField2,
    disabled2,
    option2,
    onChange2,
  ) => {
    const classLabel2 = col2 === button ? 'col-md-6 margin-button' : 'col-md-6 ';
    const classLabel1 = label2 === undefined ? 'col-md-6 labelStyle1' : 'col-md-6 labelStyle2';

    return (
      <div className="row rowHeight rightAlign">
        {col1 !== select && (
          <div className={classLabel1}>
            {col1 === input && generateInputField(label1, inputValue1, unit1, onClick, hideField1, disabled1)}
            {col1 === toggle && generateToggle(label1, onClick)}
          </div>
        )}
        {col1 === select && (
          <div className="col-md-6 ">
            {generateSelectField(label1, onClick, option1, inputValue1, unit1, onChange1)}
          </div>
        )}
        {label1 === APPDATA.FIELD_NAME.BOTTLE_PRESSURE && !hideField1 && (
          <button
            type="button"
            className="editButton"
            onClick={() => onClickEditReturnValve()}
          >
            <span className="glyphicon glyphicon-pencil " />
          </button>
        )}
        {label2 !== undefined && (
          <div className={classLabel2}>
            {col2 === input && generateInputField(label2, inputValue2, unit2, onClick, hideField2, disabled2)}
            {col2 === toggle && generateToggle(label2, onClick)}
            {col2 === select && generateSelectField(label2, onClick, option2, inputValue2, unit2, onChange2)}
            {col2 === toggleSwitch && generateSwitchField(label1, onChange1, inputValue1, true)}
          </div>
        )}
      </div>
    );
  };

  // GENERAL SETUP

  const getDataRecoveryOfLiquid = (label, onClick) => {
    const defaultRecoveryOfLiquid =
      recoveryOfLiquid === APPDATA.ENUM.RECOVERY_OF_LIQUID.None
        ? 1
        : recoveryOfLiquid === APPDATA.ENUM.RECOVERY_OF_LIQUID.Air
        ? 2
        : recoveryOfLiquid === APPDATA.ENUM.RECOVERY_OF_LIQUID.Buffer
        ? 3
        : recoveryOfLiquid === APPDATA.ENUM.RECOVERY_OF_LIQUID.Air_Buffer
        ? 4
        : 0;
    const availableBuffer = moreThan50ml === APPDATA.ENUM.MORE_THAN_50_ML.OFF;
    const recoveryOfLiquidComplete = [
      {
        label: APPDATA.ENUM.RECOVERY_OF_LIQUID.None,
        value: 1,
        onClick,
      },
      {
        label: APPDATA.ENUM.RECOVERY_OF_LIQUID.Air,
        value: 2,
        onClick,
      },
      {
        label: APPDATA.ENUM.RECOVERY_OF_LIQUID.Buffer,
        value: 3,
        onClick,
      },
      {
        label: APPDATA.ENUM.RECOVERY_OF_LIQUID.Air_Buffer.replace('_', ' & '),
        value: 4,
        onClick,
      },
    ];
    const recoveryOfLiquidWithoutBuffer = [
      {
        label: APPDATA.ENUM.RECOVERY_OF_LIQUID.None,
        value: 1,
        onClick,
      },
      {
        label: APPDATA.ENUM.RECOVERY_OF_LIQUID.Air,
        value: 2,
        onClick,
      },
    ];
    return {
      label,
      buttonProp: availableBuffer ? recoveryOfLiquidComplete : recoveryOfLiquidWithoutBuffer,
      defaultValue: defaultRecoveryOfLiquid,
      value: defaultRecoveryOfLiquid,
      onClick,
    };
  };

  const getDataSkipPriming = (onClick, label) => {
    const skipPrimingToggle = [
      {
        label: APPDATA.FIELD_NAME.PRIME_CHIP_WITH_OPTION.SAMPLE,
        value: 2,
        onClick,
        customButtonSize: true,
      },
      {
        label: APPDATA.FIELD_NAME.PRIME_CHIP_WITH_OPTION.BUFFER,
        value: 1,
        onClick,
        customButtonSize: true,
      },
    ];
    const skipPrimingValue =
      // eslint-disable-next-line no-nested-ternary
      skipPriming === APPDATA.ENUM.SKIP_PRIMING.OFF ? 1 : skipPriming === APPDATA.ENUM.SKIP_PRIMING.ON ? 2 : 0;
    return {
      // label: APPDATA.FIELD_NAME.PRIME_CHIP_WITH,
      label: label || '',
      buttonProp: skipPrimingToggle,
      defaultValue: skipPrimingValue,
      value: skipPrimingValue,
      onClick,
    };
  };

  return (
    <div style={style.constraint}>
      {activePage === AdvSetupMenu.CYCLE_SETUP && (
        <div className="mainPage">
          {/* <div className="row rowHeight middleAlign">
                        <div className="col-md-7 titlePage">
                            <h3>Concentrate</h3>
                        </div>
                    </div> */}
          <div className="row rowHeight middleAlign">
            <div className="toggleProfileType adv-cycle-setup-mode">
              <ToggleButton
                buttonProp={setupModeButtonProp}
                defaultValue={defaultAdvSetup}
                value={defaultAdvSetup}
                onClick={onClickChangeMode}
              />
            </div>
          </div>
          {generateRow(
            input,
            input,
            APPDATA.FIELD_NAME.DIAPHRAGM_PRESSURE,
            diaphragmPressure,
            APPDATA.UNIT.psi,
            undefined,
            false,
            undefined,
            undefined,
            onClick,
            APPDATA.FIELD_NAME.DIAPHRAGM_FILL_TIME,
            diaphragmFillTime,
            APPDATA.UNIT.ms,
            undefined,
            false,
            undefined,
            undefined,
          )}
          {generateRow(
            input,
            input,
            APPDATA.FIELD_NAME.BOTTLE_PRESSURE,
            returnValvePressure,
            APPDATA.UNIT.psi,
            defaultAdvSetup !== APPDATA.FIELD_NAME.ADV_BUTTON.CONCENTRATE,
            true,
            undefined,
            undefined,
            onClick,
            APPDATA.FIELD_NAME.DIAPHRAGM_EMPTY_TIME,
            diaphragmEmptyTime,
            APPDATA.UNIT.ms,
            undefined,
            false,
            undefined,
            undefined,
          )}
        </div>
      )}

      {activePage === AdvSetupMenu.GENERAL && (
        <GeneralSetup
          manualControlThreshold={manualControlThreshold}
          primingVolume={primingVolume}
          autoMixingEnabled={autoMixingEnabled}
          mixingInterval={mixingInterval}
          handleChangeMixingInterval={(value) => {
            setMixingInterval(parseInt(value, 10));
            setIsSetupChanged(true);
          }}
          mixingCycle={mixingCycle}
          handleChangeMixingCycle={(value) => {
            setMixingCycle(parseInt(value, 10));
            setIsSetupChanged(true);
          }}
          // hideMembraneFillingCycle={hideMembraneFillingCycle}
          handleSetSkipPriming={setSkipPriming}
          handleChangeManualControlThreshold={setManualControlThreshold}
          handleChangePrimingVolume={setPrimingVolume}
          generateSelectField={generateSelectField}
          generateSwitchField={generateSwitchField}
          generateToggle={generateToggle}
          handleToggleAutoMixing={() => {
            setAutoMixingEnabled(!autoMixingEnabled);
            setIsSetupChanged(true);
          }}
          handleToggleAutoRecovery={() => {
            setAutoRecoveryEnabled(!autoRecoveryEnabled);
            setIsSetupChanged(true);
          }}
          autoRecoveryEnabled={autoRecoveryEnabled}
          highVolumeBufferEnabled={highVolumeBufferEnabled}
          handleToggleHighVolumeBuffer={() => {
            setHighVolumeBufferEnabled(!highVolumeBufferEnabled);
            setIsSetupChanged(true);
          }}
        />
      )}

      <AdvSetupTopMenu activeTopMenu={APPDATA.ADVANCED_SETUP_NEW} />
      <AdvSetupPageMenu />
    </div>
  );
}

function Input(props) {
  const {label, value, unit, onClick, hideField, fullWidthInput, disabled, hideValue = false} = props;
  const valueParse = parseFloat(value);
  const inputValue = isNaN(valueParse) ? value : valueParse; // .toFixed(decimal)
  const classInputCollumn =
    unit === undefined || label === undefined ? 'flex-row divInput center' : 'flex-row divInput center';
  const classInputField = fullWidthInput ? 'inputField inputFullWitdh ' : 'inputField input-value';

  // title value value psi
  // title value
  // value psi
  return (
    <div className={classInputCollumn}>
      {label !== undefined && !hideField && (
        <span
          className="input-title"
          disabled={disabled}
        >
          {label}
        </span>
      )}
      {!hideField && !hideValue && (
        <input
          className={classInputField}
          id={label}
          value={value === APPDATA.EMPTY_FIELD ? '' : inputValue}
          readOnly
          onClick={onClick}
          disabled={disabled}
        />
      )}
      {hideValue && <div className="input-value" />}
      {unit !== undefined && !hideField && (
        <span
          className="input-unit"
          disabled={disabled}
        >
          {unit}
        </span>
      )}
    </div>
  );
}

export default AdvanceCycleSetup;
